import request from './AxiosRequest';
import axios from 'axios';
import GeneralUtility from '../utilities/generalUtility';

const variableList = [
    'SkipReferralWizardIntroVersion',
    'ShowProfileProgressContainer',
    'CCBrokerOnAgreementEmail',
    'JobRole',
    'UserTasks',
    'DefaultFeed'
];

function defer() {
    var deferred = {};
    var promise = new Promise((resolve, reject) => {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    deferred.promise = promise;
    return deferred;
}

const pendingRequests = [];

class ClientStorage {
    static initOnce = false;

    static data = null;

    static pending = [];

    static error = false;

    static cancel = null;

    componentWillUnmount() {
        GeneralUtility.cleanupRequests(pendingRequests);
    }

    static init() {
        if (ClientStorage.initOnce) {
            return;
        }

        ClientStorage.initOnce = true;

        const r = request({
            url: `/Services/api/useraccount/GetClientStorage`,
            method: 'POST',
            // data is a list of all configuration variables to request from BE
            data: variableList,
            cancel: true
        });
        ClientStorage.cancel = r.cancel;
        GeneralUtility.appendPendingRequest(pendingRequests, r);
        r.request
            .then(response => {
                const dataObj = {};
                response.data.forEach(obj => {
                    dataObj[obj.RowKey] = obj.value;
                });
                ClientStorage.data = dataObj;
                ClientStorage.pending.forEach(pendingRequest => {
                    pendingRequest.resolve(ClientStorage.data);
                });
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    ClientStorage.error = true;
                    ClientStorage.pending.forEach(pendingRequest => {
                        pendingRequest.reject(error);
                    });
                    GeneralUtility.logWebRequestFailure(error, 'GetClientStorage');
                }
            });
    }

    static browse() {
        if (!ClientStorage.initOnce) {
            ClientStorage.init();
        }
        if (ClientStorage.data) {
            return { request: Promise.resolve(ClientStorage.data), cancel: ClientStorage.cancel };
        }
        if (ClientStorage.error) {
            return { request: Promise.reject(new Error('fail')), cancel: ClientStorage.cancel };
        }
        const pendingRequest = defer();
        ClientStorage.pending.push(pendingRequest);
        return { request: pendingRequest.promise, cancel: ClientStorage.cancel };
    }

    static edit(data) {
        if (ClientStorage.data === null) {
            const pendingRequest = defer();
            return { request: pendingRequest.promise };
        }

        Object.keys(data).map(key => {
            ClientStorage.data[key] = data[key];
            return ClientStorage.data;
        });

        const r = request({
            url: `/Services/api/useraccount/PostClientStorage`,
            method: 'POST',
            data: data,
            cancel: true
        });

        GeneralUtility.appendPendingRequest(pendingRequests, r);
        return r;
    }
}

export default ClientStorage;
